import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../components/global/DynamicIcon";

/**
 * GenerateMaquinasEquipItensColumnDefinition
 */

type Props = {
  onActionEditar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDeletar: (idItemchecklist: number | null, openState: boolean) => void;
};

export const GenerateMaquinasEquipItensColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "ordem",
      headerName: "Ordem",
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "descricao",
      headerName: "Item",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },

    {
      field: "idItemMaquinaEquip",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idItemMaquinaEquip, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.row.idItemMaquinaEquip, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
